 
export const ADD_INVOICE_REQUEST = "ADD_INVOICE_REQUEST";
export const ADD_INVOICE_SUCCESS = "ADD_INVOICE_SUCCESS";
export const ADD_INVOICE_FAILURE = "ADD_INVOICE_FAILURE";

export const GET_INVOICE_DETAILS_REQUEST = "GET_INVOICE_DETAILS_REQUEST";
export const GET_INVOICE_DETAILS_SUCCESS = "GET_INVOICE_DETAILS_SUCCESS";
export const GET_INVOICE_DETAILS_FAILURE = "GET_INVOICE_DETAILS_FAILURE";

export const UPDATE_INVOICE_DETAILS_REQUEST = "UPDATE_INVOICE_DETAILS_REQUEST";
export const UPDATE_INVOICE_DETAILS_SUCCESS = "UPDATE_INVOICE_DETAILS_SUCCESS";
export const UPDATE_INVOICE_DETAILS_FAILURE = "UPDATE_INVOICE_DETAILS_FAILURE";

export const GET_INVOICE_IMAGE_REQUEST = "GET_INVOICE_IMAGE_REQUEST";
export const GET_INVOICE_IMAGE_SUCCESS = "GET_INVOICE_IMAGE_SUCCESS";
export const GET_INVOICE_IMAGE_FAILURE = "GET_INVOICE_IMAGE_FAILURE";